import React, { useState } from "react";
import {
  company_icon,
  email_icon,
  eye_icon,
  knf_logo,
  knfLogo,
  logo,
  mobile_icon,
  password_icon,
} from "../../assets/imgs";
import { useNavigate } from "react-router-dom";
import { EMAIL } from "../redux/api/Constants";
import apiRequest from "../redux/api/apiRequest";
import { toast } from "react-toastify";
import { useForgotPasswordMutation } from "../redux/api/api";
import MailOutlineRoundedIcon from "@mui/icons-material/MailOutlineRounded";

const Registration = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [err, setErr] = useState(false);
  const [loader, setLoader] = useState(false);
  const [forgotPassword] = useForgotPasswordMutation();
  const [shake, setShake] = useState(false);

  const resetPassword = async () => {
    if (!email || !email?.match(EMAIL)) {
      setErr(true);

      setShake(true);

      setTimeout(() => {
        setShake(false);
      }, 500);
      return;
    }
    const formdata = new FormData();
    formdata.append("email", email);
    setErr(false);
    setLoader(true);
    const res = await apiRequest(forgotPassword, formdata);
    setLoader(false);
    if (res?.status == "success") {
      navigate("/");
      toast.success(res?.message);
    }
    console.log(res);
  };
  return (
    <>
      <div className="knf_login_page">
        <div className="main-wrapper">
          {/* LEFT SIDE */}
          <div className="login-left">
            <img
              src={knfLogo} // your single image
              className="glass-image"
              alt="company"
            />
          </div>

          {/* RIGHT SIDE */}
          <div className="login-right">
            <div className="login-box">
              <h2 className="mt-4"> Forgot Password</h2>

              <div className="text-start">
                <p className="mt-4 f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20">
                  Email
                </p>
                <div className="login-input mt-2">
                  <MailOutlineRoundedIcon className="emial-icon" />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="Email"
                  />
                </div>
                {err && (
                  <p className="err" style={{ marginTop: "2%" }}>
                    Please enter Valid Email
                  </p>
                )}
              </div>
              <button
                disabled={loader}
                onClick={() => resetPassword()}
                className={`login-btn-knf f2 ${shake ? "shake-btn" : ""}`}
              >
                {loader ? (
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                    style={{ marginRight: "5px" }}
                  ></div>
                ) : (
                  "Login"
                )}
              </button>
              <div className="d-flex justify-content-start mt-1">
                <p
                  onClick={() => navigate("/")}
                  className="mt-5 f2 fs-sm-12 fs-md-13 fs-lg-14 fs-xl-16 fs-xxl-18 pointer text-start"
                >
                  Return to Login
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Registration;
